'use strict'

function labeledUrl (label, accountOrigin, application) {

  const url = new URL(accountOrigin)

  url.hostname = `${label}.${url.hostname}`
  url.pathname = application
    ? `/${encodeURIComponent(String(application).replace(/^\/+|\/+$/g, ''))}`
    : '/'
  url.search = ''
  url.hash = ''

  return url.toString()
}

function accountOriginFromLabeledLocation (label, location) {

  const hostname = String(location && location.hostname || '')
  const prefix = `${label}.`

  if (!hostname.startsWith(prefix)) {

    return ''
  }

  const accountHost = hostname.slice(prefix.length)

  if (!accountHost || accountHost === 'localhost' || accountHost.startsWith('.')) {

    return ''
  }

  const protocol = (location.protocol || 'http:').replace(/:$/, '')
  const port = location.port ? `:${location.port}` : ''

  return `${protocol}://${accountHost}${port}`
}

module.exports = {
  labeledUrl,
  accountOriginFromLabeledLocation
}
